import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import cache from "emun.products/lists/product-list.cache";
import modals from "webmodals/modals";

export default class ProductListPickerController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.request = {
      productId: options.product ? options.product.id : null,
      productIds: options.productIds
    };
    //console.info("BL*** request = " + JSON.stringify($ctrl.request));
    $ctrl.query = new AutoQuery({
      url: "QueryProductLists.json",
      orderBy: "-CreatedOn",
      autoLoad: true,
      pageSize: 25,
      scrub(res) {
        console.info("QueryProductLists.json", res, cache.get());
      }
    });
    $ctrl.bus = $ctrl.query.bus;

    $ctrl.title =
      options.title || options.product
        ? `Add ${options.product.id} To List...`
        : "Add Products To List...";
  }

  createListThenAdd(label) {
    const $ctrl = this;

    $ctrl.bus
      .send("CreateProductList.json", { label })
      .then(function(response) {
        $ctrl.addItem(response.data);
      });
  }

  addItem(list) {
    const $ctrl = this;
    $ctrl.request.listId = list.id;
    cache.record(list.id);
    $ctrl.bus
      .send("CreateProductListItem.json", $ctrl.request)
      .then(function(response) {
        $ctrl.$close($ctrl.request);
        $ctrl.$emit("refresh-product-lists", $ctrl.request);
      });
  }

  deleteList(list) {
    const $ctrl = this;
    $ctrl.$close($ctrl.request);
    return modals
      .confirm("Please confirm that you would like to delete this list.", "Delete Product List")
      .result.then(function() {
        $ctrl.bus
          .send("DeleteProductList.json", $ctrl.request.list)
          .then(function(response) {
            $ctrl.$emit("refresh-product-lists", response);
          });
      });
  }

  dismiss() {
    const $ctrl = this;
    //$ctrl.$emit('listSaved', $ctrl);
    $ctrl.$dismiss();
  }
}
